function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M473.985 0h-447.6c-2.4 0-2.4 2.4-2.4 4.4V80c0 1.6 0 3.2 1.6 3.6 1.6.4 2.8 0 4-.8l54.8-55.2h136v418.8l-56.4 50.4c-1.2 1.2-1.2 2.8-.8 4.4.4 1.6 2.4 2.4 4 2.4h165.6c1.6 0 3.2-1.2 3.6-2.4.4-1.6.8-3.2-.4-4.4l-56.4-50V27.6h136.4l55.2 55.6c1.2 1.2 3.6 1.6 5.2.8s3.2-2 3.2-3.6v-76c.4-2-3.2-4.4-5.6-4.4z"
});

var SvgText = function SvgText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#9193A9",
    viewBox: "0 0 503.6 503.6"
  }, props), _ref);
};

export default SvgText;